import React, { createContext, useEffect, useState ,useReducer,useContext} from 'react';
import { useHistory } from 'react-router-dom';
import httpClient,{getBaseURL,setCacheableEndpoints,setClearOnLogout,setNetworkLaterEndpoint,clearAllCache,removeAllCacheableEndpoints,setRestoreEndpoint,removeCacheItem}  from '../utility/httpClient.util';
import Loader from "../components/Loader/Loader";
import { ACCOUNT_INITIALISE, LOGIN, LOGOUT,ACCOUNT_PERSPECTIVE,ACCOUNT_CONFIG } from "../store/actions";
import accountReducer from 'store/accountReducer';
import * as actionType from "store/actions";
import { ConfigContext } from "contexts/ConfigContext";
import { TimeFormatProvider} from "contexts/TimeFormatContext"
import Swal from 'sweetalert2';
import axios from 'axios';
import i18n from '../i18n';



const LOGOUT_LOCK_KEY = 'ckd-logout-in-progress';
const LOGOUT_LOCK_TIMEOUT_MS = 30000;

const initialState = {
    isLoggedIn: false,
    isInitialised: false,
    isAdmin:false,
    user: null,
    config:[],
    perspective:[]
  };


  const AuthContext = createContext({
    ...initialState,
    login: () => Promise.resolve(),
    logout: () => { },
    logoutLocal: () => { },
    setAccountPerspective : ()=>{},
    setAccountConfig : ()=>{}
  });

export const KeycloakOauth2Provider = ({ children }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);
    const [user, setUser] = useState({permissions:[],displayName:''});
    const [config,setConfig] = useState([])
    const history = useHistory();
    const configContext = useContext(ConfigContext);


    const updateServiceWorker = () => {
        // This will tell the new service worker to take control immediately
        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
        }
        // Reload the page to let the new service worker take control
        setTimeout(() => {
            let flushDesign = localStorage.getItem('flushDesign')
            if (flushDesign) {
              localStorage.removeItem('flushDesign')
            } else {
              //window.location.href = '#/'
              //window.location.reload(true);
             // window.location.replace("/");
                const path = window.location.pathname;

                if (path !== '/his' && path !== '/') {
                    window.location.replace('/');
                } else {
                    window.location.reload();
                }
            }
        }, 100); // Adjust the delay as needed
    }

    const mergeConfigs = (config, meConfig)=> {
        // Create a map from config using configCode as the key
        const configMap = new Map(config.map(item => [item.configId, item]));

        // Iterate over meConfig and replace or add the items to configMap
        meConfig.forEach(item => {
          configMap.set(item.configId, item); // Replace if configCode exists, or add if new
        });

        // Convert the map back to an array
        return Array.from(configMap.values());
      }


    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                const isUseCacheStr = localStorage.getItem('isUseCache') || 'true'
                if(isUseCacheStr==='false'){
                    removeAllCacheableEndpoints()
                }

                const [response1, response2, response3,response4] = await Promise.all([
                    httpClient.get('/core/kc/oauth2/userinfo', { timeout: 30000 }),
                    httpClient.get('/hr/profile/me?include=employeeJob.employeePosition', { timeout: 30000 }),
                    httpClient.get('/core/config?systemServiceTypeCode=core&perPage=1000', { timeout: 30000 }),
                    httpClient.get('/core/config/me?systemServiceTypeCode=core&perPage=1000', { timeout: 30000 })
                  ]);

                //const response = await httpClient.get('/core/kc/oauth2/userinfo');
                let user = response1.data.data;


                user.permissions = user?.permissions || []
                user.displayName = user?.name || ''
                user.userId = user?.ckdUserId || ''
                user.tabId = Math.random().toString(36).substr(2, 9);

                //const response2 = await httpClient.get('/hr/profile/me');
                user = Object.assign(user,response2.data.data)
                user.displayName =  user?.name || user?.firstName + ' ' + user?.lastName
                user.positionName = user?.employeeJob?.employeePosition?.name || ''
                console.log('user',user,response2)

                setUser(user); // Set the user data on successful authentication
                sessionStorage.setItem('sessionEmployeeCode',user.employeeCode);
                //Get Config

                //const response3 = await httpClient.get(`/core/config/me?systemServiceTypeCode=core&perPage=1000`);
                let config = response3.data.data
                let meConfig = response4.data.data
                config = mergeConfigs(config, meConfig);
                setConfig(config);

                await checkFirstLoginInSession(user,config)

                //Default Lang: prefer personal profile language over org/config language.
                const profileLanguage = user?.language || null
                let findLang = config.find(({configCode})=>configCode==='user_language')  || null
                const defaultLanguage = profileLanguage || findLang?.data || null
                if(defaultLanguage){
                    localStorage.setItem('userLanguage', defaultLanguage)
                    i18n.changeLanguage(defaultLanguage)
                } else {
                    localStorage.removeItem('userLanguage')
                }

                //Default TimeFormat
                let findTime = config.find(({configCode})=>configCode==='user_time_format')  || null
                if(findTime){
                    localStorage.setItem('userTimeFormat', findTime.data)
                }

                let findFont = config.find(({configCode})=>configCode==='user_font_format')  || null
                if(findFont){
                    localStorage.setItem('userFontFormat', findFont.data)
                }

                let findCache = config.find(({configCode})=>configCode==='cacheable_endpoints')  || null
                if(findCache){
                    let endpoints = []
                    let network = []
                    let clearOnLogout = []
                    findCache.jsonData.endpoints.forEach(element => {
                        endpoints = endpoints.concat(element.items)
                        if(element.networkLater && element.networkLater===true){
                            network = network.concat(element.items)
                        }
                        if(element?.clearOnLogout && element?.clearOnLogout===true){
                            clearOnLogout = clearOnLogout.concat(element.items)
                        }
                    });

                    if(isUseCacheStr==='true'){
                        setCacheableEndpoints(endpoints)
                        setNetworkLaterEndpoint(network)
                        setClearOnLogout(clearOnLogout)
                    }else{
                        setRestoreEndpoint(endpoints,network)
                    }
                }


                const subpath = getSubpath();

                // Ensure the subpath is correctly formatted
                const formattedSubpath = subpath.endsWith('/') ? subpath : `${subpath}/`;
                const timestamp = Date.now()
                const response = await axios.get(
                    `${formattedSubpath}manifest.json?v=${timestamp}`,
                    { timeout: 10000 }
                ).catch((error) => {
                    console.warn('Unable to check app version', error);
                    return null;
                });
                const manifestResult = response?.data

                let find = config.find(({configCode})=>configCode==='ckdoctor_api_version')
                let cfgVersion = find?.data|| '0.1.0'
                let version = localStorage.getItem('ckdoctor_build_version') || '0.1.0'
                let apiVersion = localStorage.getItem('ckdoctor_api_version') || '0.1.0'

                if(manifestResult?.version && ((apiVersion != cfgVersion) || (version && version !=manifestResult.version))){
                    //Skip And Reload
                    Swal.fire({
                        icon: 'warning',
                        title: 'Notification',
                        html: `Version ${manifestResult.version}-${cfgVersion} now available. Update to enjoy new features and improvements.`,
                        allowOutsideClick: false,
                        showCancelButton: false,
                        confirmButtonText: 'OK, Update',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Later',
                        }).then(async (result) => {
                        if (result.isConfirmed) {
                            localStorage.setItem('ckdoctor_build_version', manifestResult.version)
                            localStorage.setItem('ckdoctor_api_version',cfgVersion);

                            clearAllCache(()=>{
                                updateServiceWorker()
                            },()=>{
                                updateServiceWorker()
                            })
                        }
                        })
                }


                //debugger
                dispatch({
                    type: ACCOUNT_INITIALISE,
                    payload: {
                    isLoggedIn: true,
                    user,
                    config,
                    isAdmin: user.permissions.includes('role:ckdoctor:admin')
                    }
                });

                //Config
                applyUserTheme(config)

                 // const decodedState = atob(state); // "#/user-event"
                //window.location.hash = decodedState;
                const urlParams = new URLSearchParams(window.location.search);
                const state = urlParams.get('state');
                if (state) {
                    try {
                      const decoded = decodeURIComponent(atob(state));
                      window.location.hash = decoded; // e.g., "#/user-event"
                    } catch (e) {
                      console.warn('Invalid state format');
                    }
                }




            } catch (error) {
                window.ckdStartup?.complete();
                if (error.response && error.response.status === 401) {
                    // User is not authenticated, redirect to login
                    //window.alert('Error checking authentication 401')
                    //window.location.href = `${getBaseURL()}/oauth2/start?rd=${encodeURIComponent(window.location.href)}`;

                } else {
                    //window.location.href = `${getBaseURL()}/oauth2/start?rd=${encodeURIComponent(window.location.href)}`;
                    //window.alert('Error checking authentication')
                    console.error('Error checking authentication', error);
                    Swal.fire({
                        icon: 'warning',
                        title: 'Error Loading...',
                        text: `Please try reload`,
                        confirmButtonText: 'Click Reload',
                        confirmButtonColor: '#3085d6'
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                            window.location.reload()
                        }
                      })
                }
                dispatch({
                    type: ACCOUNT_INITIALISE,
                    payload: {
                      isLoggedIn: false,
                      user,
                      config
                    }
                  });

            }
        };

        const checkFirstLoginInSession = async (user,config)=>{
            if(user?.firstLoginInSession && user?.firstLoginInSession===true){
                    //Check Device && remove all cache when first login
                    removeAllCacheableEndpoints()
                    //Check device
                    try{
                        const response = await httpClient.get('/core/kc/account/oauth2/userinfo');
                        const {devices,limitLoginDevice,trustedDevice,isTrustedDevice} = response.data.data

                        if(limitLoginDevice && limitLoginDevice*1 >0 && devices.length > limitLoginDevice*1){
                            //Modal
                            dispatch({
                                type: ACCOUNT_INITIALISE,
                                payload: {
                                isLoggedIn: false,
                                user,
                                config
                                }
                            });

                            const currentSession = devices.find(({current})=>current && current===true)
                            await deleteAllSessions(currentSession)
                            Swal.fire({
                                icon: 'error',
                                title: 'Access Denied',
                                text: 'You must log out other devices before continuing.',
                                confirmButtonText: 'OK',
                                allowEscapeKey: false,       // ❌ ห้ามกด Escape
                                allowOutsideClick: false     // ❌ ห้ามคลิกพื้นหลังเพื่อปิด
                            }).then(async () => {
                                //logout(config)
                                const currentBrowserUrl = `${getBaseURL()}/oauth2/start?rd=${encodeURIComponent(window.location.href)}`;
                                window.location.href = currentBrowserUrl
                            });


                        }else if(isTrustedDevice*1===0){
//Modal
                            dispatch({
                                type: ACCOUNT_INITIALISE,
                                payload: {
                                isLoggedIn: false,
                                user,
                                config
                                }
                            });

                            const currentSession = devices.find(({current})=>current && current===true)
                            await deleteAllSessions(currentSession)
                            Swal.fire({
                                icon: 'error',
                                title: 'Access Denied',
                                text: "Device not trusted or access forbidden",
                                confirmButtonText: 'OK',
                                allowEscapeKey: false,       // ❌ ห้ามกด Escape
                                allowOutsideClick: false     // ❌ ห้ามคลิกพื้นหลังเพื่อปิด
                            }).then(async () => {
                                //logout(config)
                                const currentBrowserUrl = `${getBaseURL()}/oauth2/start?rd=${encodeURIComponent(window.location.href)}`;
                                window.location.href = currentBrowserUrl
                            });
                        }
                    }catch(err){

                            // Handle other errors
                        console.error(err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Access Denied',
                            text: 'Device validate error. Please try again by refresh browser',
                            confirmButtonText: 'OK',
                            allowEscapeKey: false,       // ❌ ห้ามกด Escape
                            allowOutsideClick: false     // ❌ ห้ามคลิกพื้นหลังเพื่อปิด
                        }).then(async () => {

                        });

                    }

            }
        }

        const deleteAllSessions = async (currentSession) => {
            const sessions = currentSession?.sessions || [];

            for (const s of sessions) {
                const sessionId = s.id;
                try {
                    await httpClient.delete(`/core/kc/account/sessions/${sessionId}`);
                    console.log(`Deleted session: ${sessionId}`);
                } catch (err) {
                     console.error(`Failed to delete session ${sessionId}`, err);
                }
            }
        };


        const checkSocket = async ()=>{
            try{
                const [response4] = await Promise.all([
                    httpClient.post('/socket/notification/user-auth')
                ]);
                //Post Token
                const socketToken = sessionStorage.getItem('socketToken') || null
                //debugger
                //if(!socketToken){

                    //const response4 = await httpClient.post('/socket/notification/user-auth')
                    console.log('r4',response4)
                    sessionStorage.setItem('socketToken',response4?.data?.data.access_token)
                //}
            }catch(ex){
                //No Problem
            }
        }

        checkAuthentication();
        checkSocket();
    }, []);

    const login = async () => {
        window.location.href = `${getBaseURL()}/oauth2/start?rd=${encodeURIComponent(window.location.href)}`;
    };

    const logout = (newConfig=[]) => {
        // Implement OIDC RP-Initiated Logout following specification
        // https://openid.net/specs/openid-connect-rpinitiated-1_0.html

        let allCfg = mergeConfigs(config, newConfig);
        removeCacheItem('/core/config/me?systemServiceTypeCode=core&perPage=1000');

        let logoutUrlConfig = allCfg.find(item => item.configCode === 'logout_url');
        let clientIdConfig = allCfg.find(item => item.configCode === 'client_id');

        const logoutStartedAt = Number(localStorage.getItem(LOGOUT_LOCK_KEY));
        if (logoutStartedAt && Date.now() - logoutStartedAt < LOGOUT_LOCK_TIMEOUT_MS) {
            dispatch({ type: LOGOUT });
            return;
        }
        localStorage.setItem(LOGOUT_LOCK_KEY, String(Date.now()));

        const publicUrl = process.env.PUBLIC_URL || '';
        const appPath = publicUrl && publicUrl !== '.'
            ? new URL(publicUrl, window.location.origin).pathname.replace(/\/$/, '')
            : '';
        const baseUrl = window.location.origin + appPath;
        let logoutUrl = baseUrl;

        if (logoutUrlConfig?.data && clientIdConfig?.data) {
            const logoutUrlObject = new URL(logoutUrlConfig.data, window.location.origin);
            logoutUrlObject.searchParams.set('client_id', clientIdConfig.data);
            logoutUrlObject.searchParams.set('post_logout_redirect_uri', baseUrl);
            logoutUrl = logoutUrlObject.toString();
        } else {
            // Still clear the OAuth2 Proxy session when OIDC logout config
            // cannot be loaded, such as on the unauthorized screen.
            console.warn('Missing logout configuration, using local sign-out fallback');
        }
        let oauth2SignOutUrl = `${getBaseURL()}/oauth2/sign_out?rd=${encodeURIComponent(logoutUrl)}`;

        //console.log('logout',logoutUrl,oauth2SignOutUrl)
        window.location.href = oauth2SignOutUrl;
    };

    // A logout initiated by another browser tab has already invalidated the
    // shared OAuth2 session. Do not call the remote logout endpoint again,
    // because concurrent sign-out requests can make the second tab fail.
    const logoutLocal = async () => {
        removeCacheItem('/core/config/me?systemServiceTypeCode=core&perPage=1000');
        sessionStorage.removeItem('socketToken');
        sessionStorage.removeItem('sessionEmployeeCode');
        setUser({permissions:[],displayName:''});
        dispatch({ type: LOGOUT });
    };

    const applyUserTheme = (newConfig)=>{
        let cfg = newConfig.find(({configCode})=>configCode==='organization_theme')
        if(cfg && cfg.jsonData){
            const localUserTheme = JSON.parse(localStorage.getItem('ck-doctor-user-theme'))
            //console.log("local",localUserTheme)
            const userTheme = localUserTheme || cfg.jsonData
            configContext.dispatch({
                type: actionType.USER_THEME,
                userTheme : {...userTheme,isInitTheme:false}
              });
        }

        cfg = newConfig.find(({configCode})=>configCode==='user_font_format')
        if(cfg && cfg.data){
            const localUserFont = localStorage.getItem('userFontFormat')
            const userFont = localUserFont || cfg.data
            configContext.dispatch({
                type: actionType.USER_FONT,
                userFont : userFont
              });
        }
    }

    const applyUserTimeFormat = (newFormat)=>{

    }


    const getSubpath = () => {
        const pathname = window.location.pathname;
        // Assuming your app is deployed at a subpath like /app or /his
        const subpath = pathname.split('/')[1];
        return subpath ? `/${subpath}` : '';
    };

    const setAccountPerspective = (perspective)=>{
        dispatch({
            type: ACCOUNT_PERSPECTIVE,
            payload: {
              perspective
            }
          });
    }

    const setAccountConfig = (config)=>{
        dispatch({
            type: ACCOUNT_CONFIG,
            payload: {
              config
            }
          });
    }


    if (!state.isInitialised) {
        return <Loader />;
    }

    return (
            <AuthContext.Provider value={{...state, user, logout, logoutLocal, setAccountPerspective,setAccountConfig }}>
                <TimeFormatProvider>
                    {children}
                </TimeFormatProvider>
            </AuthContext.Provider>
    );
};

export default AuthContext;
